exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{border-radius:2px;background-color:#fafafa;border-bottom:.15rem solid #f3f2ed}:host,:host .container{display:flex;flex-direction:column}:host .container{padding-top:2rem;padding-bottom:2rem}:host .container .btn-group{width:100%;justify-content:flex-end;margin-top:0}:host .container .btn-group jhi-button:first-child{margin-right:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/depot-requete/steps/requerants/add-requerant-section/edit-form/edit-form.component.scss
// module id = 678
// module chunks = 0